import {useState} from "react";
import PropTypes from "prop-types";

import {US_STATE_VALUES} from "shared/constants/usState";
import {getMeta} from "shared/networking/tools";
import {requestAssistance} from "shared/networking/assistance";

import BaseModal from "shared/modals/BaseModal";
import ButtonInput from "shared/components/ButtonInput";
import SelectInput from "shared/components/SelectInput";
import TextInput from "shared/components/TextInput";

import './styles.scss';


function RequestAssistanceModal({show, onClose, goToAssistanceSubmitted}) {
    const [name, setName] = useState();
    const [state, setState] = useState();
    const [phone, setPhone] = useState();
    const [email, setEmail] = useState();
    const [questions, setQuestions] = useState();

    const agency = {
        logo: getMeta('agencyLogo'),
        name: getMeta('agencyName'),
    };

    const stateChoices = [
        {value: '', label: 'Choose...'},
        ...US_STATE_VALUES.map(value => ({value, label: value})),
    ];

    return <BaseModal className={"RequestAssistanceModal"} show={show} onClose={onClose}>
        <img src={agency.logo} alt={agency.name}/>
        <h1 className={"RequestAssistanceModal__Title"}>Request Professional Assistance</h1>

        <div className={"RequestAssistanceModal__Label"}>Name</div>
        <TextInput placeholder={"Name"} required={true} value={name} onChange={setName}/>

        <div className={"RequestAssistanceModal__Label"}>State</div>
        <SelectInput
            value={state}
            choices={stateChoices}
            required={true}
            onChange={event => setState(event.target.value)}
        />

        <div className={"RequestAssistanceModal__Label"}>Phone Number</div>
        <TextInput type={'tel'} placeholder={"Phone Number"} required={true} value={phone} onChange={setPhone}/>

        <div className={"RequestAssistanceModal__Label"}>Email</div>
        <TextInput type={'email'} placeholder={"Email"} required={true} value={email} onChange={setEmail}/>

        <div className={"RequestAssistanceModal__Label"}>Questions/Comments </div>
        <TextInput rows={3} placeholder={"Questions/Comments"} required={false} value={questions} onChange={setQuestions}/>

        <div className={"RequestAssistanceModal__ButtonSection"}>
            <ButtonInput
                disabled={!name || !state || !phone || !email}
                onClick={async () => {
                    await requestAssistance(name, state, phone, email, questions);
                    onClose();
                    goToAssistanceSubmitted();
                }}
            >
                Request Assistance</ButtonInput>
            <ButtonInput outline={true} onClick={onClose}>Close</ButtonInput>
        </div>
    </BaseModal>;
}

RequestAssistanceModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default RequestAssistanceModal;
